/// <amd-module name="Wit/MentionsAutocomplete/WorkItemAutocompleteCommand" />
import { IMarkdownToolbarCommand } from "VSS/Features/MarkdownEditor/Commands/Toolbar";
import { insertText } from "VSS/Features/MarkdownEditor/Formatting/Common";
import { IMarkdownFormattingArgs, IMarkdownFormattingResult } from "VSS/Features/MarkdownEditor/Formatting/Contracts";
import { IIconProps } from "VSSUI/Icon";
import * as Resources from "Wit/MentionsAutocomplete/Resources";

export class WorkItemAutocompleteCommand implements IMarkdownToolbarCommand {
    private workItemCharacter = "#";
    public id = "workitem-autocomplete";
    public iconProps: IIconProps = { iconName: "NumberSymbol" };
    public text = Resources.WorkItemToolbarCommandText;
    public rank = 100;

    public formatText = (formattingArgs: IMarkdownFormattingArgs, errorHandler: (error: Error) => void): IMarkdownFormattingResult => {
        return insertText(formattingArgs, this.workItemCharacter);
    };
}
